module.exports = __webpack_public_path__ + "static/media/arrow-left-carousel.8fec3959.svg";